<template>
	<div>
		<base-form-dialog
			ref="payerInfoDialog"
			btnRightText="提交订单"
			form-option-num-temp="6"
			is-form
			title="付款人信息"
			width="45%"
			@onClickRight="onSubmitResult">
			<template slot="form_bottom">
				<div style="margin-left: 20px">
					<el-checkbox v-model="insureFirst">
						本人确认已获得上述投保企业授权支付保费，若发生退费，原路返还至交款账户
					</el-checkbox>
					<el-checkbox v-model="insureSecond" style="margin-top: 5px">
						我已仔细阅读并同意《保险条款》《投保须知》等内容
					</el-checkbox>
				</div>
				<div style="display: flex; justify-content: center; margin-top: 40px; margin-bottom: 20px">
					<el-button plain style="margin-right: 20px; width: 100px" type="primary" @click="onCancel">取消</el-button>
					<el-button
						:loading="isSubmitLoading"
						style="margin-left: 20px; width: 100px"
						type="primary"
						@click="onSubmit">
						提交订单
					</el-button>
				</div>
			</template>
		</base-form-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import BaseFormDialog from '@/components/insurance/baseFormDialog'

export default {
	name: 'payerInfo',
	mixins: [],
	components: {BaseFormDialog},
	props: {},
	data() {
		return {
			insureFirst: false,
			insureSecond: false,
			isSubmitLoading: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		onSubmit() {
			if (!this.insureFirst || !this.insureSecond) {
				this.$message.error('请阅读相关内容，并确认勾选')
				return
			}
			this.$refs.payerInfoDialog.onClickRight()
		},
		onCancel() {
			this.$refs.payerInfoDialog.hide()
		},
		onSubmitResult(formData) {
			//回调,请求数据
			this.isSubmitLoading = true
			setTimeout(() => {
				this.$emit('onPayerInfo', formData)
				this.isSubmitLoading = false
				this.onCancel()
			}, 1500)
		},
		showDialog() {
			this.$refs.payerInfoDialog.show()
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox__label {
	display: inline-grid;
	white-space: pre-line;
	word-wrap: break-word;
	overflow: hidden;
	line-height: 20px;
}
</style>
